import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
import { AddressGet } from '../models/address-get';

@Injectable()
export class LocationService {

  private _addressesUrl: string = `${environment.apiRootURL}/addresses`;
  private _mapquestUrl: string = `${environment.geolocationURL}${environment.geolocationKey}`;
  private _geocodeUrl: string = 'https://geocoding.geo.census.gov/geocoder/locations/onelineaddress?benchmark=9&format=json&address=';

  constructor(private _http: Http) { }

  getCityStateFromZip(zipCode: string) {
    console.log('HTTP GET City/State from Zip Code');
    const zip = (zipCode.length > 5) ? zipCode.substr(0, 5) : zipCode;
    return this._http.get(`${this._addressesUrl}/zip/${zip}`).map(response => response.json());
  }

  validateAddress(address: AddressGet) {
    const options = new RequestOptions();
    options.headers = new Headers();
    options.headers.append('Content-Type', 'application/json');
    console.log('HTTP POST Verify Address');
    return this._http.post(`${this._addressesUrl}/verifyAddress`, JSON.stringify(address), options).map(response => response.json());
//    return this._http.get(`${this._addressesUrl}/VerifyAddress/${zipCode}`).map(response => response.json());
  }

  getGeocodeFromAddress(address: string){
    console.log('HTTP GET Geocode from Address');
    const aUrl = `${this._mapquestUrl}&location=${address}`;
    // const aUrl = this._geocodeUrl + address;
    return this._http.get(aUrl).map(response => response.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/location.service.ts